// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// This utility provides the correct API URL for both development and production environments

export const getApiUrl = () => {
  // In production, use same origin (the app is served from the same domain as the API)
  // In development, use the env variable
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.origin}/api`;
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

// For backwards compatibility, export as API constant
// Note: This is evaluated at module load time, so it works for most cases
export const API = typeof window !== 'undefined' 
  ? getApiUrl() 
  : (process.env.REACT_APP_BACKEND_URL || '') + '/api';
